// src/App.js - Updated with AppInitializer and improved routing
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ShopListPage from './pages/ShopListPage';
import ShopDetailPage from './pages/ShopDetailPage';
import RegisterShopPage from './pages/RegisterShopPage';
import UserRegistrationPage from './pages/UserRegistrationPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import EditShopPage from './pages/EditShopPage';
import ChangePlanPage from './pages/ChangePlanPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import ImpressumPage from './pages/ImpressumPage';
import TermsPage from './pages/TermsPage';
import NotFoundPage from './pages/NotFoundPage';
import ReportShopPage from './pages/ReportShopPage';
import AdminReportedShopsPage from './pages/AdminReportedShopsPage';
import EmailVerificationPage from './pages/EmailVerificationPage';
import VerifyEmailNoticePage from './pages/VerifyEmailNoticePage';
import BundeslandPage from './pages/BundeslandPage';
import AppInitializer from './components/AppInitializer';
import AdminRoute from './components/AdminRoute';
import './App.css';

// Helper component to scroll to top on route change
function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null; // This component does not render anything
}

function App() {
    useEffect(() => {
        // Check if placeholder images directory exists
        const checkForPlaceholderImage = () => {
            const img = new Image();
            img.onload = () => console.log('Placeholder image loaded successfully');
            img.onerror = () => console.warn('Placeholder image not found - using default fallbacks');
            img.src = '/images/placeholder-shop.svg';
        };

        checkForPlaceholderImage();
    }, []);

    return (
        <HelmetProvider>
            <Router>
                <ScrollToTop />
                <AppInitializer>
                    <div className="app">
                        <Header />
                        <main className="main-content">
                            <Routes>
                                <Route path="/" element={<HomePage />} />
                                {/* Shop list route with optional query params */}
                                <Route path="/shops" element={<ShopListPage />} />
                                {/* Individual shop detail route */}
                                <Route path="/shops/:id" element={<ShopDetailPage />} />
                                {/* Shop reporting route */}
                                <Route path="/shop-melden" element={<ReportShopPage />} />
                                {/* Bundesland-Seiten (Dynamische Route - VEREINFACHT ZUM TEST) */}
                                <Route path="/bl/:bundeslandSlug" element={<BundeslandPage />} />
                                {/* Registration routes */}
                                <Route path="/register" element={<RegisterShopPage />} />
                                <Route path="/user-register" element={<UserRegistrationPage />} />
                                {/* Auth routes */}
                                <Route path="/login" element={<LoginPage />} />
                                <Route path="/verify-email/:token" element={<EmailVerificationPage />} />
                                <Route path="/verify-email-notice" element={<VerifyEmailNoticePage />} />
                                {/* Dashboard routes */}
                                <Route path="/dashboard" element={<DashboardPage />} />
                                <Route path="/dashboard/edit-shop/:id" element={<EditShopPage />} />
                                <Route path="/dashboard/change-plan/:id" element={<ChangePlanPage />} />
                                <Route path="/dashboard/change-password" element={<ChangePasswordPage />} />
                                {/* Static pages */}
                                <Route path="/about" element={<AboutPage />} />
                                <Route path="/contact" element={<ContactPage />} />
                                <Route path="/privacy" element={<PrivacyPage />} />
                                <Route path="/impressum" element={<ImpressumPage />} />
                                <Route path="/agb" element={<TermsPage />} />
                                {/* Admin routes */}
                                <Route element={<AdminRoute />}>
                                    <Route path="/admin/reported-shops" element={<AdminReportedShopsPage />} />
                                </Route>
                                {/* 404 page - MUST BE LAST */}
                                <Route path="*" element={<NotFoundPage />} />
                            </Routes>
                        </main>
                        <Footer />
                    </div>
                </AppInitializer>
            </Router>
        </HelmetProvider>
    );
}

export default App;